export const isValidEmail = (string) => {
  return RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/).test(
    string
  );
};
